import * as Yup from 'yup';

import {
  createMaxMessage,
  createMinMessage,
  createRequiredMessage,
} from '@domain/validations';

/**
 * Generates a validation schema for parameters using Yup.
 *
 * @returns {Yup.ObjectSchema} - The validation schema for parameters.
 */
export const getParameterValidationSchema = () => {
  const parameterValidationSchema = Yup.object<any>().shape({
    name: Yup.string()
      .min(1, createMinMessage('name', 1))
      .max(100, createMaxMessage('name', 100))
      .required(createRequiredMessage('name')),
    description: Yup.string()
      .optional()
      .min(1, createMinMessage('description', 1))
      .max(10000, createMaxMessage('description', 10000)),

    type: Yup.string()
      .oneOf(['TEXT', 'NUMBER'], 'Invalid type')
      .required(createRequiredMessage('type')),

    creationType: Yup.string()
      .oneOf(['RANDOM', 'CONSTANT'])
      .when('type', {
        is: 'NUMBER',
        then: Yup.string().required(createRequiredMessage('creationType')),
        otherwise: Yup.string().notRequired(),
      }),

    value: Yup.mixed().when('type', {
      is: 'TEXT',
      then: Yup.string().required(createRequiredMessage('value')),
      otherwise: Yup.mixed().when('creationType', {
        is: 'CONSTANT',
        then: Yup.number().required(createRequiredMessage('value')),
        otherwise: Yup.mixed().notRequired(),
      }),
    }),

    min: Yup.number().when(['type', 'creationType'], {
      is: (type: any, creationType: any) =>
        type === 'NUMBER' && creationType === 'RANDOM',
      then: Yup.number()
        .required(createRequiredMessage('min'))
        .max(Yup.ref('max'), 'Min must be less than max'),
      otherwise: Yup.number().notRequired(),
    }),

    max: Yup.number().when(['type', 'creationType'], {
      is: (type: any, creationType: any) =>
        type === 'NUMBER' && creationType === 'RANDOM',
      then: Yup.number()
        .required(createRequiredMessage('max'))
        .min(Yup.ref('min'), 'Max must be greater than min'),
      otherwise: Yup.number().notRequired(),
    }),
  });

  return parameterValidationSchema;
};

export const StructureDataParameterValidationSchema = () => {
  const parameterValidationSchema = Yup.object<any>().shape({
    name: Yup.string()
      .min(1, createMinMessage('name', 1))
      .max(100, createMaxMessage('name', 100))
      .required(createRequiredMessage('name')),
    value: Yup.mixed().when('type', {
      is: 'TEXT',
      then: Yup.string().required(createRequiredMessage('value')),
      otherwise: Yup.mixed().when('creationType', {
        is: 'NUMBER',
        then: Yup.number().required(createRequiredMessage('value')),
      }),
    }),
  });

  return parameterValidationSchema;
};
